var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLocations(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "locations-icon-sidebar-clippath"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#707070",
    d: "M-8884-5546h20v20h-20z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#locations-icon-sidebar-clippath)",
    transform: "translate(8884 5546)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M-8877.937-5545.797a1.923 1.923 0 0 1 1.72 0l5.122 2.561a.385.385 0 0 0 .344 0l3.968-1.984a1.923 1.923 0 0 1 2.783 1.72v12.8a1.923 1.923 0 0 1-1.063 1.72l-5 2.5a1.923 1.923 0 0 1-1.72 0l-5.122-2.557a.385.385 0 0 0-.344 0l-3.968 1.984a1.923 1.923 0 0 1-2.783-1.72v-12.804a1.923 1.923 0 0 1 1.063-1.72Zm.86 3.507a.769.769 0 0 1 .769.769v8.462a.769.769 0 0 1-1.538 0v-8.462a.769.769 0 0 1 .769-.769Zm6.927 3.077a.769.769 0 0 0-1.538 0v8.462a.769.769 0 1 0 1.538 0Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocations);
export default __webpack_public_path__ + "static/media/locations.8e28b530c8d1d29da50eba244e428d0e.svg";
export { ForwardRef as ReactComponent };